<template>
  <v-container fill-height>
    <v-layout justify-center align-content-space-around>
      <v-flex lg7 md7 sm8 xs12>
        <h2 class="amaze-title">Amaze</h2>
        <p>Welcome back! Please login to your account.</p>
        <v-form
          id="loginForm"
          ref="loginForm"
          v-model="valid"
          @keyup.enter.native="submitForm()"
          class="mt-5"
        >
          <v-text-field
            label="E-mail Address"
            v-model="email"
            :rules="emailRules"
            required
          ></v-text-field>
          <v-text-field
            name="input-10-1"
            label="Password"
            hint="Passwords are case sensitive."
            v-model="password"
            :rules="passwordRules"
            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
            @click:append="showPassword = !showPassword"
            :type="showPassword ? 'text' : 'password'"
            required
          ></v-text-field>
          <v-layout>
            <!-- <v-flex justify-start>
              <v-checkbox
                name="remember-me"
                label="Remember me"
                v-model="remember"
                color="primary"
                class="pt-0 ma-0"
              ></v-checkbox>
            </v-flex> -->
          </v-layout>
          <v-btn color="primary" class="mt-2 mb-4" @click="submitForm()">
            Login
          </v-btn>
          <v-flex class="text-xs-center">
            <router-link to="forgot-password" warning
              >Forgot your password?</router-link
            >
          </v-flex>
        </v-form>
        <login-google v-if="googleLogin"></login-google>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style scoped lang="scss">
#loginForm {
  .v-text-field {
    min-height: 5em;
  }
}
</style>

<script>
import LoginGoogle from "./LoginGoogle";

export default {
  components: {
    LoginGoogle
  },
  data() {
    return {
      remember: false,
      valid: false,
      email: "",
      emailRules: [v => !!v || "E-mail Address is required"],
      password: "",
      passwordRules: [v => !!v || "Password is required"],
      googleLogin: process.env.VUE_APP_GOOGLE_SSO === "enabled",
      showPassword: false
    };
  },
  methods: {
    submitForm() {
      if (this.$refs.loginForm.validate()) {
        this.$auth.login({
          fetchUser: true,
          // The redirect will take you to the dashboard by default,
          // but if you attempted to access a page that required authorization
          // before you logged in, this will redirect you to that page.
          redirect: this.$route.query.page
            ? this.$route.query.page
            : "/dashboard",
          body: {
            email: this.email,
            password: this.password
          },
          error(res) {
            this.$store.commit("updateMessage", {
              message:
                "Sorry, your username or password is incorrect. Try again!",
              snackbar: true
            });
          }
        });
      } else {
        this.$store.commit("updateMessage", {
          message:
            "Nice try, but some required information is missing. Give it another go!",
          snackbar: true
        });
      }
    }
  }
};
</script>
